<template>
    <div class="information">
        <!-- 修改信息 -->
        <div v-if="isChangeInformation" class="information_container change">
            <div class="avatar">
                <div class="avatar_image change_avatar">
                    <img style="width: 3.06rem; height: 3.06rem; border-radius: 90%;" :src="userInfo.avatar ? userInfo.avatar : require('../../../assets/image/资源 38.png')">
                    <div class="upload_avatar">
                        <el-upload 
                            :headers="uploadHeaders"
                            :action="getNoSecretAction()"
                            :data="{type: 'avatar'}"
                            :limit="1" :on-change="handleChangeAvatar"
                            :on-success="handleSuccessAvatar" 
                            :on-error="handleErrorFile" ref="upload"
                            :on-exceed="handleExceedFile">
                            <el-button v-if="!isUploadAvatar" >点击上传</el-button>
                            <el-button v-else class="finishBtn">上传完成</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div class="information_content change_content">
                <el-form ref="form" :rules="rules" :model="userInfo" label-width="80px">
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="userInfo.username"></el-input>
                    </el-form-item>
                    <el-form-item label="昵称" prop="nickname">
                        <el-input v-model="userInfo.nickname" maxlength="20"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="密码">
                        <el-input v-model="information[1].password"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="邮箱">
                        <el-input v-model="userInfo.email"></el-input>
                    </el-form-item> -->
                    <el-form-item label="生日" prop="birthday">
                        <el-date-picker  v-model="userInfo.birthday"></el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item label="手机号">
                        <el-input v-model="userInfo.phone"></el-input>
                    </el-form-item> -->
                    <el-form-item label="企业名称" prop="unit">
                        <el-input v-model="userInfo.unit" maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="企业描述" prop="unitIntro">
                        <el-input v-model="userInfo.unitIntro" type="textarea" :rows="3" maxlength="200"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="button_container">
                <el-button @click="changeInformationBtn">确认修改</el-button>
                <el-button @click="cancelInformationBtn">取消修改</el-button>
            </div>
        </div>
        <!-- 展示信息 -->
        <div class="information_container show" v-else>
            <div class="avatar">
                <div class="avatar_image">
                    <img style="width: 3.06rem; height: 3.06rem; border-radius: 90%;" :src="userInfo.avatar ? userInfo.avatar : require('../../../assets/image/资源 38.png')">
                    <span>{{ userInfo.nickname }}</span>
                </div>
                <div class="button">
                    <el-button type="primary" round @click="changeInformation">修改基本信息</el-button>
                </div>
            </div>
            <div class="information_content">
                <ul>
                    <li v-for="(item, index) in information" :key="index">
                        <div :class="['item', item.item==='password' ? 'pass' : '']">
                            <div class="detail">
                                <span class="name">{{item.name}}</span>
                                <span class="value" :style="{'display' : item.item === 'unitIntro' ? 'contents' : ''}">{{ userInfo[`${item.item}`] ? userInfo[`${item.item}`] : item.value}}</span>
                            </div>
                            <div v-if="item.item==='password'" class="button">
                                <el-button type="primary" round @click="changePassword">修改密码</el-button>
                            </div>
                            <div v-if="item.item==='wxOpenid'" class="button">
                                <el-button v-if="userInfo.wx !== '已绑定微信'" type="primary" round @click="bindWXin">立即绑定</el-button>
                                <el-button v-else type="primary" round @click="bindWXin">更换绑定</el-button>
                            </div>
                            <div v-if="item.item==='phone'" class="button">
                                <el-button v-if="!userInfo.phone" type="primary" round @click="bindPhone">立即绑定</el-button>
                                <el-button v-else type="primary" round @click="bindPhone">更换绑定</el-button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 二维码弹窗 -->
        <div v-show="dialogVisible" class="wx_dialog_toiast">
            <div class="wx_dialog_toiast_delltet" id="login_container"></div>
            <div class="wx_dialog_button_delete" @click="close_wchat_qrcode">
                <i class="el-icon-circle-close" style="color: #fff; font-size: 30px ; cursor: pointer;"></i>
            </div>
        </div>
        <!-- <el-dialog center :visible.sync="dialogVisible">
            <div class="dialog_container">
                <p>绑定微信</p>
                <wxlogin appid="wxd6125d826622af59" scope="snsapi_login" :theme="'black'" :redirect_uri='encodeURIComponent("http://www.pongo.net.cn/")' :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlewogICAgICAgICAgICAgICAgICAgIGRpc3BsYXk6IG5vbmU7CiAgICAgICAgICAgICAgICB9'"></wxlogin>
            </div>
        </el-dialog> -->
        <el-dialog center :visible.sync="isBindPhone" width="50%" @close="handleClose">
            <el-form :model="formPhone" ref="formPhone" :rules="rulesPhone" label-width="80px">
                <el-form-item prop="phone" label="手机号：">
                    <el-input style="width: 80%;" v-model="formPhone.phone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="code" label="验证码：">
                    <el-input style="width: 80%;" v-model="formPhone.code" autocomplete="off">
                        <el-button slot="append" @click="getCode" class="login"
                        type="primary"
                        :disabled="isSending || countdown > 0">
                            {{ isSending ? '发送中...' : countdown > 0 ? `${countdown}秒后重试` : "获取验证码" }}
                        </el-button>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <div class="button">
                        <el-button @click="userToLogin" type="primary" class="login">提&nbsp;&nbsp;交</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { baseUrl } from '../../../util/constant';
import { mapState } from 'vuex'
import qs from 'qs'
import { Axios } from 'axios';
import { formatTimestampToDate } from '../../../util/tool';
import { userInfo, bindWx, getUserInfo, changeUserInfo, checkRepeat, changeUserPhone, getVerifyCode } from '../../../util/index'
// import { getMyInformation } from '../../../api/api'
export default {
    data(){
        // 手机号
        var checkNum = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('手机号不能为空'));
            }
            setTimeout(() => {
                // console.log(value);
                var myReg=/^[1][3,4,5,7,8][0-9]{9}$/;
                if (!myReg.test(value) ) {
                    callback(new Error('请输入正确的手机号码'));
                } else {
                    callback();
                }
            }, 1000);
        };
        // 验证码
        var checkCode = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('验证码不能为空'));
            }
            setTimeout(() => {
                // console.log(value);
                var myReg=/^[0-9]{6}$/;
                if (!myReg.test(value) ) {
                    callback(new Error('请输入正确的6位数验证码'));
                } else {
                    callback();
                }
            }, 1000);
        };
        return{
            isChangeInformation:false,
            information:[
                {
                    item:'username',
                    name:'账  号:',
                    value:'168888888'
                },
                {
                    item:'password',
                    name:'密  码:',
                    value:'已设置密码'
                },
                {
                    item:'birthday',
                    name:'生  日:',
                    value:'未设置生日'
                },

                {
                    item:'phone',
                    name:'电  话:',
                    value:'168888888'
                },
                // {
                //     item:'email',
                //     name:'邮  箱:',
                //     value:'未设置邮箱'
                // },
                {
                    item:'wxOpenid',
                    name:'微  信:',
                    state:false,
                    value:'未绑定微信'
                },
                {
                    item:'unit',
                    name:'企业名称:',
                    value:'未添加企业名'
                },
                {
                    item:'unitIntro',
                    name:'企业描述:',
                    value:'未添加企业描述'
                },
            ],
            userInfo:{},
            dialogVisible: false,
            isUploadAvatar: false,
            isBind: false,
            isBindPhone: false,
            isSending: false,
            countdown: 0,
            avatarUrl:'',
            rules: {
                username: [
                    { 
                        validator: async (rule, value, callback) => {
                            // 检测用户名是否更改
                            if (this.userInfo.username === value) {
                                callback();
                                return;
                            }
                            if (value==='') {
                                return callback(new Error('用户名不能为空'));
                            } else if (!/^[a-zA-Z0-9_-]+$/.test(value)) {
                                return callback(new Error('用户名只能包含字母、数字、下划线或横线'));
                            } else if (!/^.{6,20}$/.test(value)) {
                                return callback(new Error('用户名长度必须在6到20个字符之间'));
                            }
                            // 获取 token
                            const token = window.localStorage.getItem('userToken');
                            
                            try {
                                // 检查用户名是否重复
                                const isRepeat = await checkRepeat('username', value, token);
                                if (!isRepeat.data) {
                                    callback(new Error("用户名已存在"));
                                } else {
                                    callback(); // 验证通过
                                }
                            } catch (error) {
                                callback(new Error("验证失败，请重试"));
                            }
                        }, 
                        required: true,
                        trigger: 'blur' 
                    }
                ],
                nickname: [
                    { required: true, message: '请输入昵称', trigger: 'blur' },
                ]
            },
            formPhone: {
                phone: '',
                code: ''
            },
            rulesPhone: {
                phone: [
                { 
                        validator: async (rule, value, callback) => {
                            const token = window.localStorage.getItem('userToken');
                            if (value === '') {
                                callback(new Error('手机号不能为空'));
                            }
                            setTimeout(() => {
                                // console.log(value);
                                var myReg=/^[1][3,4,5,7,8][0-9]{9}$/;
                                if (!myReg.test(value) ) {
                                    callback(new Error('请输入正确的手机号码'));
                                } else {
                                    callback();
                                }
                            }, 0);
                            try {
                                // 检查用户名是否重复
                                const isRepeat = await checkRepeat('phone', value, token);
                                if (!isRepeat.data) {
                                    callback(new Error("手机号已绑定"));
                                } else {
                                    callback(); // 验证通过
                                }
                            } catch (error) {
                                callback(new Error("验证失败，请重试"));
                            }
                        }, 
                        required: true,
                        trigger: 'blur' 
                    }
                ],
                code: [
                    { validator: checkCode, trigger: 'blur', required: true }
                ],
            }
        }
    },
    components: {
        // wxlogin
    },
    computed: {
        ...mapState({
            info: state => state.userInformation.name
        }), 
        uploadHeaders() {
            return {
                Authorization: window.localStorage.getItem('userToken')
            }
        }
    },
    methods: {
        // checkUsername(){
        //     let token = window.localStorage.getItem('userToken')
        //     checkRepeat('username', this.userInfo.username, token).then((res) => {
        //         if(res.data.data){
        //             // this.$message.success('用户名可用')
        //         }else{
        //             this.$message.error('用户名已存在')
        //         }
        //     })
        // },
        startCountdown(){
            this.countdown = 60;
            const timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(timer);
                }
            }, 1000);
        },
        handleClose() {
            // 清除
            this.$refs['formPhone'].resetFields();
            this.$refs['formPhone'].clearValidate();
            this.dialogVisible = false;
        },
        getCode(){
            if(this.countdown > 0 || this.isSending) {
                return
            }
            let obj = {
                phone: this.formPhone.phone,
            }
            if(!obj.phone){
                this.$message.info('请输入手机号');
                this.isSending = false;
                return
            }
            this.isSending = true;
            this.startCountdown();
            getVerifyCode(obj).then((res) => {
                if(res.code === 200){
                    this.$message({
                        message: '验证码已发送',
                        type: 'success'
                    });
                    this.isSending = false;
                }
            })
        },
        userToLogin(){
            let obj = {
                phone: this.formPhone.phone,
                code: this.formPhone.code,
            }
            this.$refs['formPhone'].validate((valid) => {
                if(valid){
                    let token = window.localStorage.getItem('userToken')
                    changeUserPhone(obj, token).then(res=> {
                        if(res.code === 200){
                            this.$message({
                                message: '已更换绑定',
                                type: 'success'
                            });
                            this.isBindPhone = false;
                            this.drawUserForm()
                        }
                    })
                }
            })
        },
        getNoSecretAction() {
            return baseUrl + '/upload/image'
        },
        handleChangeAvatar(){

        },
        handleSuccessAvatar(response, file){
            // console.log(response);
            // this.avatarUrl = response.data.fileUrl
            this.userInfo.avatar = response.data.fileUrl
            this.isUploadAvatar = true
        },
        handleErrorFile(){

        },
        handleExceedFile(){
            this.$message.error('只能上传一个文件')
        },
        changeInformation(){
            this.isChangeInformation = true
        },
        changeInformationBtn(){
            let obj = {
                "username": this.userInfo.username,
                "nickname": this.userInfo.nickname,
                "avatar": this.userInfo.avatar,
                "birthday": this.userInfo.birthday,
                "unit": this.userInfo.unit,
                "unitIntro": this.userInfo.unitIntro
            }
            // 表单验证
            this.$refs['form'].validate((valid) => {
                if(valid){
                    let token = window.localStorage.getItem('userToken')
                    changeUserInfo(obj, token).then((res) => {
                        // console.log(res);
                        if(res.code == 200){
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            })
                            this.isUploadAvatar = false
                            this.isChangeInformation = false
                            this.userInfo.birthday = formatTimestampToDate(this.userInfo.birthday)
                            // 修改本地信息
                            window.localStorage.setItem('userName', obj.username)
                            // 修改导航栏的信息
                            this.$bus.$emit('changeUserInfo', {username:obj.username, avatar:obj.avatar})
                            // this.$store.dispatch('getUserInformation')
                        }else{
                            this.$message.error(res.message)
                        }
                    })
                }else{
                    this.$message.error('请确保信息符合规范')
                }
            })
            
            // console.log(birthday);
        },
        cancelInformationBtn(){
            this.isChangeInformation = false
        },
        changePassword(){
            this.$router.push('/changePwd')
        },
        bindWXin(){
            this.dialogVisible = true
        },
        bindPhone(){
            this.isBindPhone = true
        },
        drawUserForm() {
            let obj = {
                token: window.localStorage.getItem('userToken'),
                // id: window.localStorage.getItem('userId')
            }
            getUserInfo(obj).then(res=>{
                if (res.code === 200){
                    this.userInfo = res.data
                    if(res.data.status === '2'){
                        this.userInfo.password = '未设置密码'
                    }else{
                        this.userInfo.password = '已设置密码'
                    }
                    this.userInfo.birthday = formatTimestampToDate(res.data.birthday)
                    // this.avatarUrl = res.data.avatar
                    if(res.data.hasWxOpenid){
                        this.userInfo.wx = '已绑定微信'
                        this.information[4].value = '已绑定微信'
                    } else {
                        this.userInfo.wx = '暂未绑定微信'
                    }
                    if(res.data.phone){
                        this.userInfo.phone = res.data.phone
                        this.information[3].value = res.data.phone
                    }else{
                        this.userInfo.phone = '暂未绑定手机号'
                    }
                } else if (res.code == '-1'){
                    this.$message.error(res.message)
                    this.$router.push('/')
                    this.$bus.$emit('openLogin', false)
                }
                else {
                    this.$message.error(res.message)
                }
            })
        },
        close_wchat_qrcode(){
            this.dialogVisible = false
        },
        get_wx_qrcode(){
            this.$nextTick(()=>{
                let DDNS = 'http://www.pongo.net.cn/user/user_info'
                let DDNS_resolution = encodeURIComponent(DDNS)
                var obj = new WxLogin({
                    self_redirect: false,
                    id: "login_container",       //需要承载二维码的容器id  
                    appid: "wxd6125d826622af59",
                    scope: "snsapi_login",     //网页授权，目前网页只有这一种方式，静默授权
                    redirect_uri: DDNS_resolution,     //回调域名
                    state: Math.random(),
                    style: "white",
                    href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlewogICAgICAgICAgICAgICAgICAgIGRpc3BsYXk6IG5vbmU7CiAgICAgICAgICAgICAgICB9',
                });
            })    
        },
        // 获取微信回调信息并且绑定账号
        Get_wechat_callback_information() {
            // 从路由中获取code
            let code = this.$route.query.code;
            if (code) {
                let obj = {
                    code: code,
                }
                let token = window.localStorage.getItem('userToken')
                bindWx(obj, token).then(res => {
                    if (res.code == 200){
                        this.$message.success('微信绑定成功')
                        // 清掉路由中的code
                        const url = new URL(window.location);
                        url.search = ''; // 清除所有参数
                        history.replaceState(null, '', url.toString());
                        // 更新信息
                        this.drawUserForm()
                    }else if(res.code === 401){
                        this.$message.error('该微信已绑定其他账号，请更换微信账号')
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }
        
        },
    },
    mounted(){
        this.drawUserForm()
        this.get_wx_qrcode();   //获取微信的登录二维码
    },
    created(){
        this.Get_wechat_callback_information();
    },
    watch: {
    }
}
</script>

<style scoped lang="less">
.wx_dialog_toiast {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .wx_dialog_toiast_delltet {
    width: 500px;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .wx_dialog_button_delete {
    position: relative;
    right: 145px;
    top: -200px;
    height: 100px;
    width: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
::v-deep .el-form-item__content{
    width: 50rem;
}
::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 50rem;
}
.show{
    .avatar{
        ::v-deep .el-button{
            height: 10px;
            // width: 150px;
            line-height: 0px;
            background-color: #54d1ef;
            border: none;
            position: absolute;
            right: 50%;
        }
    }
    
}
::v-deep .el-dialog__body{
    display: flex;
    justify-content: center;
}
:v-deep .el-upload-list{
    margin-left: 2rem;
}
.information{
    padding-bottom: 3.38rem;
    padding: 3.5rem 5rem;
    .dialog_container{
        p{
            font-size: 1.5rem;
            text-align: center;
            letter-spacing: 5px;
            color: #000;
        }
    }
    .information_container{
        .avatar{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0 2.63rem;
            width: 100%;
            margin: 0 auto;
            position: relative;
            // background-color: rgb(255, 211, 247);

            .avatar_image{
                font-size: 1rem;
                display: flex;
                align-items: center;
                span{
                    padding-left: 0.69rem;
                    font-size: 0.85rem;
                    line-height: 1.33rem;
                    color: #666666;
                }
                ::v-deep .el-button{
                    right: 45% !important;
                }
            }
            .button{
                display: flex;
                align-items: center;
                // position: relative;
                ::v-deep .el-button{
                    width: 6.94rem;
                    height: 1.25rem;
                    font-size: 0.85rem;
                    padding: 0.25rem 1rem;
                    // line-height: 1.25rem;
                    // background-color: red;
                }
            }
            .change_avatar{
                .upload_avatar{
                    padding-left: 2rem;
                }
                button{
                    border: none;
                    background-color: #54d1ef;
                    color: #fff;
                    // height: 2rem;
                    // width: 6rem;
                    font-size: 1rem;
                    border-radius: 5px;
                    // margin-left: 2rem;
                    cursor: pointer;
                }
            }
        }
        .information_content{
            width: 100%;
            margin: 0 auto;
            border-top: 1px dashed #CCCCCC;
            padding: 2rem 0;
            ul li{
                .item{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    // padding: 1rem;
                    // background-color: rgb(255, 212, 212);
                    margin-bottom: 2px;
                    position: relative;
                    .detail{
                        // background-color: rgb(141, 255, 211);
                        .name{
                            color: #999999;
                            font-size: 0.97rem;
                            line-height: 3.75rem;
                            display: inline-block;
                            width: 6.44rem;
                        }
                        .value{
                            color: #666666;
                            display: inline-block;
                            font-size: 0.97rem;
                            line-height: 3.75rem;
                            width: 18.7rem;
                            // background-color: rgb(255, 211, 247);
                        }
                        // ::v-deep .el-button{
                        //     position: absolute;
                        //     background-color: #CCCCCC;
                        //     right: 47%;
                        //     width: 6.94rem;
                        //     height: 1.25rem;
                        //     font-size: 0.85rem;
                        //     padding: 0.25rem 1rem;
                        // }
                    }
                    .button{
                        position: relative;
                        left: 0;
                        width: 10rem;
                        height: 3rem;
                        display: flex;
                        align-items: center;
                        // background-color: pink;
                        ::v-deep .el-button{
                            position: absolute;
                            border: none;
                            background-color: #54ceec;
                            left: 0%;
                            width: 6.94rem;
                            height: 1.25rem;
                            font-size: 0.85rem;
                            padding: 0.25rem 1rem;
                        }
                    }
                }
            }
        }
        .change_content{
            ::v-deep .el-form-item__label{
                text-align: justify;
                text-align-last: justify;
            }
        }
        .button_container{
            display: flex;
            justify-content: center;
        }
    }
}
</style>